import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchOrderByID } from "../../../services/orderService";
import CostumerInfo from "../../../components/user/CostumerInfo";
import Loader from "../../../components/Loader";
import { useTranslation } from "react-i18next";

const OrderDetail = () => {
  const {t} = useTranslation();
  const { order, loader } = useSelector((state) => state.order);
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchOrderByID(id));
  }, [dispatch, id]);

  if (loader) return <Loader />
  return (
    <>
   
      <div className="p-6 bg-gray-100 min-h-screen">
        <div className="head-order">
            <h1 className="text-3xl font-semibold text-gray-800 mb-2">Order #{order[0].numOrder} </h1>
            <br />
            <span className={`px-4 py-2 link-${order[0].status}`}>{order[0].status}</span>
            <p className="m-2">{t('order.orderDate')}: {order[0].createdAt}</p>
        </div>
        <div className="flex space-x-4">
          <div className="w-2/3 bg-white rounded-lg shadow-lg p-6">
            <table className="min-w-full bg-white border border-gray-200">
              <thead>
                <tr>
                  <th className="py-2 px-4 border-b border-gray-200 text-left text-gray-600 font-medium">
                    {t('order.orderItem')}
                  </th>
                  <th className="py-2 px-4 border-b border-gray-200 text-left text-gray-600 font-medium">
                    {t('order.unitPrice')}
                  </th>
                  <th className="py-2 px-4 border-b border-gray-200 text-left text-gray-600 font-medium">
                    {t('quantity')}
                  </th>
                  <th className="py-2 px-4 border-b border-gray-200 text-left text-gray-600 font-medium">
                    {t('order.total')}
                  </th>
                </tr>
              </thead>
              <tbody>

                {order[0].orderItems.map(orderItem => (

                
                  <tr className="hover:bg-gray-100">
                    <td className="py-3 px-4 border-b border-gray-200 text-gray-800 flex items-center">
                      <img
                        src={orderItem.product.image}
                        alt={orderItem.product.name}
                        className="w-12 h-12 mr-4 rounded"
                      />
                      <div>
                        <div className="font-semibold">
                          {orderItem.product.name}
                        </div>
                        <div className="text-sm text-gray-500">
                          {orderItem.product.category.name}
                        </div>
                      </div>
                    </td>
                    <td className="py-3 px-4 border-b border-gray-200 text-gray-800">
                      {orderItem.product.price}
                    </td>
                    <td className="py-3 px-4 border-b border-gray-200 text-gray-800">
                      {orderItem.quantity}
                    </td>
                    <td className="py-3 px-4 border-b border-gray-200 text-gray-800">
                      {orderItem.amount}
                    </td>
                  </tr>
                  ))
                }
              </tbody>
            </table>
            <div className="mt-4 flex justify-between">
              <span className="text-gray-700">{t('itemsTotal')}:</span>
              <span className="text-lg font-semibold">{order[0].totalAmount}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-700">{t('shipping')}:</span>
              <span className="text-lg font-semibold">30 MAD</span>
            </div>
            <div className="flex justify-between text-xl font-bold mt-4">
              <span>{t('orderTotal')}:</span>
              <span>53000 MAD</span>
            </div>
          </div>

          {/* Sidebar for Customer Info, Payment, and Shipping */}
          <div className="w-1/3 space-y-4">
            <CostumerInfo />

            {/* Payment Status */}
            <div className="bg-white rounded-lg shadow-lg p-4">
              <h2 className="text-xl font-semibold text-gray-700">{t('order.payment')}</h2>
              <div className="mt-2 text-gray-700">
                <span>{t('method')}: </span>
                <span>Name methode</span>
              </div>
              <button className="bg-primaryColor text-white rounded-md px-4 py-2 mt-4">
                Complete Payment
              </button>
            </div>

            {/* Shipping Status */}
            <div className="bg-white rounded-lg shadow-lg p-4">
              <h2 className="text-xl font-semibold text-gray-700">{t('shipping')}</h2>
              <div className="mt-2 text-gray-700">
                <span>Carrier: </span>
                <span>Lorem ipsum dolor sit.</span>
              </div>
              <button className="bg-primaryColor text-white rounded-md px-4 py-2 mt-4">
                Ship Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderDetail;
